import { render } from "./TwitchUser.vue?vue&type=template&id=2d3b5694"
import script from "./TwitchUser.vue?vue&type=script&lang=ts"
export * from "./TwitchUser.vue?vue&type=script&lang=ts"
script.render = render

export default script